export const TEMP_GOOGLE_MEET_MARKETING_LONG_DESCRIPTION = `
<div class="long-description-container">
   <div class="long-description">
      <div class="title">Description</div>
      <div class="description">
         Google Meet is a video conferencing tool that allows users to have online meetings, share screens, and collaborate in real time. By integrating Google Meet, you can manage and conduct your meetings from the platform with just a few clicks.
      </div>
      <div class="line-divider">
      </div>
   </div>
   <div class="long-description">
      <div class="title">What does it do?</div>
      <div class="description">Here are some popular ways to use this integration.</div>
   </div>

   <div class="icon-row">
      <div class="icon-container">
        <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24.5" cy="24" r="24" fill="#FFEBEE"/>
          <path d="M29.5 22.5V19C29.5 18.45 29.05 18 28.5 18H16.5C15.95 18 15.5 18.45 15.5 19V29C15.5 29.55 15.95 30 16.5 30H28.5C29.05 30 29.5 29.55 29.5 29V25.5L33.5 29.5V18.5L29.5 22.5Z" fill="#212121"/>
        </svg>
      </div>
      <div class="icon-description-container">
         <div class="icon-description-title">
            Automatically record and transcribe meetings
         </div>
         <div class="icon-description-desc">
            The platform syncs with your calendar to identify your meetings—no manual steps required. Every scheduled meeting is recorded and transcribed in real time, so you can focus on the conversation instead of taking notes.
         </div>
      </div>
   </div>

   <div class="icon-row">
      <div class="icon-container">
        <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24.5" cy="24" r="24" fill="#F0EBF8"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0824 13C18.1746 13 18.2532 13.0665 18.2684 13.1572C18.4529 14.2616 18.8185 15.0705 19.3523 15.6475C19.8849 16.2233 20.5999 16.5842 21.5133 16.7665C21.6014 16.7841 21.6648 16.8613 21.6648 16.951C21.6648 17.0407 21.6014 17.1179 21.5133 17.1355C19.7238 17.4926 18.6343 18.9199 18.2673 20.7508C18.2497 20.8387 18.1723 20.902 18.0824 20.902C17.9925 20.902 17.9152 20.8387 17.8975 20.7508C17.5306 18.9199 16.441 17.4926 14.6516 17.1355C14.5634 17.1179 14.5 17.0407 14.5 16.951C14.5 16.8613 14.5634 16.7841 14.6516 16.7665C15.5649 16.5842 16.2799 16.2233 16.8126 15.6475C17.3463 15.0705 17.712 14.2616 17.8964 13.1572C17.9116 13.0665 17.9902 13 18.0824 13ZM25.0962 14.2571C25.3381 14.2571 25.5446 14.4317 25.5844 14.6698C26.0686 17.5688 27.0284 19.6922 28.4295 21.2069C29.8277 22.7184 31.7045 23.6658 34.1022 24.1443C34.3335 24.1904 34.5 24.3931 34.5 24.6285C34.5 24.8639 34.3335 25.0667 34.1022 25.1129C29.4049 26.0503 26.5448 29.7968 25.5815 34.603C25.5352 34.8338 25.3321 35 25.0962 35C24.8603 35 24.6571 34.8338 24.6108 34.603C23.6475 29.7968 20.7874 26.0503 16.0902 25.1129C15.8588 25.0667 15.6923 24.8639 15.6923 24.6285C15.6923 24.3931 15.8588 24.1904 16.0902 24.1443C18.4878 23.6658 20.3646 22.7184 21.7629 21.2069C23.1639 19.6922 24.1238 17.5688 24.6079 14.6698C24.6477 14.4317 24.8542 14.2571 25.0962 14.2571Z" fill="#212121"/>
        </svg>
      </div>
      <div class="icon-description-container">
         <div class="icon-description-title">
            Generate smart meeting summaries
         </div>
         <div class="icon-description-desc">
            The platform automatically surfaces next steps, follow-ups, and must-know takeaways—so you and your team stay aligned and accountable. Each meeting is also evaluated for sales effectiveness and overall sentiment. Our smart scoring gives you a quick pulse on how the meeting actually went—beyond what was said.
         </div>
      </div>
   </div>

   <div class="icon-row">
      <div class="icon-container">
        <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24.5" cy="24" r="24" fill="#E8F5E9"/>
          <path d="M24.5 16V13L20.5 17L24.5 21V18C27.81 18 30.5 20.69 30.5 24C30.5 25.01 30.25 25.97 29.8 26.8L31.26 28.26C32.04 27.03 32.5 25.57 32.5 24C32.5 19.58 28.92 16 24.5 16ZM24.5 30C21.19 30 18.5 27.31 18.5 24C18.5 22.99 18.75 22.03 19.2 21.2L17.74 19.74C16.96 20.97 16.5 22.43 16.5 24C16.5 28.42 20.08 32 24.5 32V35L28.5 31L24.5 27V30Z" fill="#212121"/>
        </svg>
      </div>
      <div class="icon-description-container">
         <div class="icon-description-title">
            Log activity in the CRM
         </div>
         <div class="icon-description-desc">
            All your recorded meetings and transcripts are automatically linked to the relevant contacts or companies in your CRM. That means no more copy-pasting notes or chasing follow-ups. Everything lives exactly where your team works.
         </div>
      </div>
   </div>

   <div class="icon-row">
      <div class="icon-container">
        <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24.5" cy="24" r="24" fill="#FFECB3"/>
          <path d="M21.5 33C21.5 33.5 21.9 34 22.5 34H26.5C27.1 34 27.5 33.5 27.5 33V32H21.5V33ZM24.5 14C20.6 14 17.5 17.1 17.5 21C17.5 23.4 18.7 25.5 20.5 26.7V29C20.5 29.5 20.9 30 21.5 30H27.5C28.1 30 28.5 29.5 28.5 29V26.7C30.3 25.4 31.5 23.3 31.5 21C31.5 17.1 28.4 14 24.5 14Z" fill="#212121"/>
        </svg>
      </div>
      <div class="icon-description-container">
         <div class="icon-description-title">
            Share key insights
         </div>
         <div class="icon-description-desc">
            No more siloed conversations or buried takeaways. With just one click, you can share recordings, summaries, and action items directly with your team—so everyone stays in the loop, even if they weren't in the room.
         </div>
      </div>
   </div>

   <div class="icon-row">
      <div class="icon-container">
       <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24.5" cy="24" r="24" fill="#E3F2FD"/>
        <path d="M16.4 24C16.4 22.29 17.79 20.9 19.5 20.9H23.5V19H19.5C16.74 19 14.5 21.24 14.5 24C14.5 26.76 16.74 29 19.5 29H23.5V27.1H19.5C17.79 27.1 16.4 25.71 16.4 24ZM20.5 25H28.5V23H20.5V25ZM29.5 19H25.5V20.9H29.5C31.21 20.9 32.6 22.29 32.6 24C32.6 25.71 31.21 27.1 29.5 27.1H25.5V29H29.5C32.26 29 34.5 26.76 34.5 24C34.5 21.24 32.26 19 29.5 19Z" fill="#212121"/>
       </svg>
      </div>
      <div class="icon-description-container">
         <div class="icon-description-title">
            Share meetings links through Calendar
         </div>
         <div class="icon-description-desc">
            Set Google Meet as your default meeting provider and get a video conferencing link and meeting details shared automatically with your contacts upon booking a meeting through Calendar.
         </div>
      </div>
   </div>

   <div class="line-divider"></div>
   <div class="long-description">
      <div class="title">How does it work?</div>
      <div class="description">Simply sign in to your Google account to set up the connection.</div>
   </div>
</div>
`;
